import { render, staticRenderFns } from "./dashboardUnpublishedUnit.vue?vue&type=template&id=139fb650&scoped=true&"
import script from "./dashboardUnpublishedUnit.vue?vue&type=script&lang=js&"
export * from "./dashboardUnpublishedUnit.vue?vue&type=script&lang=js&"
import style0 from "./dashboardUnpublishedUnit.vue?vue&type=style&index=0&id=139fb650&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139fb650",
  null
  
)

export default component.exports